import Vue from 'vue'
import Router from 'vue-router'
import i18n from "@/lang";
import {
  consumeNavigationSource,
  getScrollPosition,
  setPageScrollPosition
} from '@/utils/pageNavigation'

Vue.use(Router)
Vue.use(i18n)

/* Layout */
import Layout from '../views/layout/Layout'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
 title: 'title'               the name show in submenu and breadcrumb (recommend set)
 icon: 'svg-name'             the icon show in the sidebar,
 }
 **/
export const constantRouterMap = [
  {path: '/login', component: () => import('@/views/login/index'), hidden: true},
  {path: '/forgotPassword', component: () => import('@/views/forgotPassword/index'), hidden: true},
  {path: '/register/:code?', component: () => import('@/views/register/index'), hidden: true},
  {path: '/shopApplyCountry', redirect: '/shopApply', hidden: true},
  {path: '/shopApply', component: () => import('@/views/register/shopApply.vue'), hidden: true},
  {path: '/entryByIndividual', component: () => import('@/views/register/entryByIndividual.vue'), hidden: true},
  {path: '/entryByCompany', component: () => import('@/views/register/entryByCompany.vue'), hidden: true},

  {path: '/404', component: () => import('@/views/404'), hidden: true},
  {
    path: '',
    component: Layout,
    redirect: '/home',
    meta: {title: i18n.t('system.home'), icon: 'home',keepRootLayout: true,},
    hidden: true,
    children: [
      {
        path: 'home',
        name: 'home',
        component: () => import('@/views/home/index.vue'),
        meta: {title: i18n.t('system.home'), icon: 'dashboard', keepAlive: true},
      },
      {
        path: 'homeReport',
        name: 'homeReport',
        component: () => import('@/views/home/report.vue'),
        meta: {title: i18n.t('home.reportDetailTitle')},
        hidden: true
      },
      {
        path: 'profile',
        name: 'profile',
        component: () => import('@/views/layout/components/profile'),
        meta: {title: i18n.t('system.myAccount'), icon: 'dashboard'},
        hidden: true
      },
      {
        path: '/messageIM',
        name: 'messageIM',
        component: () => import('@/views/IM/im.vue'),
        meta: {title: i18n.t('im.messageNotifications'), icon: 'review'},
        hidden: true
      },
       // 站内信通知
      {
        path: '/notifications',
        name: 'Notifications',
        component: () => import('@/views/IM/notifications/index.vue'),
        meta: {title: i18n.t('im.messageNotifications'), icon: 'review'},
        hidden: true
      },
    ]
  },
  {path: '/IM', component: () => import('@/views/IM/im.vue'), hidden: true},
  // 微信支付
  {
    path: '/payByWeChat',
    name: 'payByWeChat',
    component: () => import('@/views/fund/accountCenter/component/payByWeChat.vue'),
    hidden: true
  },
  {
    path: '/detailLayout',
    name: 'detailLayout',
    redirect: '/newOrderDetail',
    component: () => import('@/views/detailLayout/index.vue'),
    hidden: true,
    meta: {title: i18n.t('order.orderDetails')},
    children: [
      {
        path: '/newOrderDetail',
        name: 'newOrderDetail',
        component: () => import('@/views/oms/order/orderDetail/index.vue'),
        meta: {
          title: i18n.t('order.orderDetails') ,
          showSidebar: false,
          detailPage: true,
          defaultParentName: 'order'
        },
      },
      {
        path: '/afterSaleDetail',
        name: 'afterSaleDetail',
        component: () => import('@/views/oms/order/afterSaleDetail/index.vue'), //orderAuditList
        meta: {
          title: i18n.t('menu.AfterSalesDetails'),
          icon: 'review',
          showSidebar: false,
          detailPage: true,
          defaultParentName: 'orderAuditList'
        },
        hidden: true
      },

      //
      {
        path: 'shippingSetting',
        name: 'shippingSetting',
        component: () => import('@/views/pms/myWarehouse/components/shippingSetting.vue'),
        meta: {
          title: i18n.t('settings.deliveryInfo'),
          icon: 'product-attr',
          showSidebar: false,
          detailPage: true,
          defaultParentName: 'myWarehouse'
        },
        hidden: true
      },
      {
        path: 'stripe',
        name: 'stripe',
        component: () => import('@/views/fund/stripe/stripePage.vue'),
        meta: {title: 'stripe' ,showSidebar: false },
        hidden: true
      },
    ]
  },
]

export const asyncRouterMap = [
  // 商品
  {
    path: '/pms',
    component: Layout,
    redirect: '/pms/myProducts',
    name: 'pms',
    meta: {title: i18n.t('menu.product'), icon: 'product',keepRootLayout: true,},
    children: [
      {
        path: 'productHome',
        name: 'productHome',
        component: () => import('@/views/pms/productDetails/product-home.vue'),
        meta: {title: i18n.t('menu.addProduct'), icon: 'product-attr', keepAlive: true}
      },
      {
        path: 'myProducts',
        name: 'myProducts',
        component: () => import('@/views/pms/myProduct/index.vue'),
        meta: {title: i18n.t('menu.myProducts'), icon: 'product-attr', keepAlive: true}
      },
      {
        path: 'myDraft',
        name: 'myDraft',
        component: () => import('@/views/pms/myDraft/index.vue'),
        meta: {title: i18n.t('menu.productTemplate'), icon: 'product-add', keepAlive: true}
      },
      {
        path: 'myWarehouse',
        name: 'myWarehouse',
        component: () => import('@/views/pms/myWarehouse/index.vue'),
        meta: {title: i18n.t('menu.warehouseAudit'), icon: 'product-attr', keepAlive: true}
      },
      {
        path: 'productDetails',
        name: 'productDetails',
        component: () => import('@/views/pms/productDetails/index.vue'),
        meta: {title: i18n.t('product.fillInProductDetails'), icon: 'product-attr',showSidebar: false,detailPage: true},//  showSidebar: false
        hidden: true
      },
      {
        path: 'productReadonly',
        name: 'productReadonly',
        component: () => import('@/views/pms/productReadonly/index.vue'),
        meta: {title: i18n.t('menu.productDetails'), icon: 'product-attr', detailPage: true},
        hidden: true
      },
    ]
  },
  // 货架
  {
    path: '/shop',
    component: Layout,
    redirect: '/shop/shopInfo',
    name: 'cms',
    meta: {title: i18n.t('menu.operator'), icon: 'ums',keepRootLayout: true,},
    children: [
      {
        path: 'shopUser',
        name: 'shopUser',
        component: () => import('@/views/cms/myOperator'),
        meta: {title: i18n.t('menu.userList'), icon: 'ums-admin', keepAlive: true}
      },
      {
        path: 'profile',
        name: 'profile',
        component: () => import('@/views/layout/components/profile'),
        meta: {title: i18n.t('system.myAccount'), icon: 'ums-resource'},
        hidden: true
      },
      {
        path: 'myAccount',
        name: 'myAccount',
        component: () => import('@/views/cms/myAccount/index.vue'),
        meta: {title: i18n.t('system.myAccount'), icon: 'ums-resource'},
        hidden: true
      },
      {
        path: 'authorizedStore',
        name: 'authorizedStore',
        component: () => import('@/views/cms/authorizedStore/index.vue'),
        meta: {title: i18n.t('product.authorizedStore'), icon: 'ums-resource'},
        hidden: true
      },
    ]
  },
  // 资金
  {
    path: '/fund',
    component: Layout,
    redirect: '/fund/accountCenter',
    name: 'fund',
    meta: {title: i18n.t('menu.fund'), icon: 'line-file-pound',keepRootLayout: true,},
    children: [
      // 账户中心
      {
        path: 'accountCenter',
        name: 'accountCenter',
        component: () => import('@/views/fund/accountCenter/index.vue'),
        meta: {title: i18n.t('menu.accountCenter'), icon: 'product-list', keepAlive: true}
      },
      // 账单管理
      {
        path: 'billManagement',
        name: 'billManagement',
        component: () => import('@/views/fund/billManagement/index.vue'),
        meta: {title: i18n.t('menu.billManagement'), icon: 'product-list', keepAlive: true}
      },
      {
        path: 'payment',
        name: 'payment',
        component: () => import('@/views/fund/accountCenter/component/payment.vue'),
        meta: {title: i18n.t('settlement.estimatedAdjustment'), icon: 'product-list'},
        hidden: true
      },
      {
        path: 'settleDetails',
        name: 'settleDetails',
        component: () => import('@/views/fund/billManagement/settleDetails.vue'),
        meta: {
          title: i18n.t('menu.settleDetails'),
          icon: 'product-list',
          detailPage: true,
          defaultParentName: 'billManagement'
        },
        hidden: true
      },
      {
        path: 'estimateDetails',
        name: 'estimateDetails',
        component: () => import('@/views/fund/billManagement/estimateDetails.vue'),
        meta: {
          title: i18n.t('menu.settleDetails'),
          icon: 'product-list',
          detailPage: true,
          defaultParentName: 'billManagement'
        },
        hidden: true
      },
    ]
  },
  // 订单
  {
    path: '/oms',
    component: Layout,
    redirect: '/oms/order',
    name: 'oms',
    meta: {title: i18n.t('menu.order'), icon: 'order',keepRootLayout: true,},
    children: [
      {
        path: 'orderAuditList',
        name: 'orderAuditList',
        component: () => import('@/views/oms/order/orderAuditList'), //orderAuditList
        meta: {title: i18n.t('menu.orderAuditList'), icon: 'review', keepAlive: true}
      },
      {
        path: 'order',
        name: 'order',
        component: () => import('@/views/oms/order/newIndex.vue'),
        meta: {title: i18n.t('menu.orderList'), icon: 'product-list', keepAlive: true}
      },
    ]
  },
  {path: '*', redirect: '/404', hidden: true},
]


// 解决重复点击菜单会控制台报错bug
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}

const router = new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior(to, from, savedPosition) {
    const navigationSource = consumeNavigationSource()
    let position = {x: 0, y: 0}

    if (navigationSource === 'breadcrumb') {
      const scrollTop = getScrollPosition(to.name)
      if (scrollTop !== null) {
        position = {x: 0, y: scrollTop}
      }
    } else if (savedPosition) {
      position = savedPosition
    }

    Vue.nextTick(() => {
      setPageScrollPosition(position)
    })

    return false
  },
  routes: constantRouterMap
})

const noForwardEntryRoutes = ['/entryByCompany', '/entryByIndividual']
let shouldClearEntryForwardHistory = false

if (typeof window !== 'undefined') {
  // 必须在 Vue Router 的 popstate 处理前记录离开的路由，统一覆盖两个入驻页面
  window.addEventListener('popstate', () => {
    shouldClearEntryForwardHistory = noForwardEntryRoutes.includes(router.currentRoute.path)
  }, true)

  router.afterEach((to, from) => {
    if (!shouldClearEntryForwardHistory) return
    shouldClearEntryForwardHistory = false
    if (!noForwardEntryRoutes.includes(from.path)) return

    const currentState = window.history.state && typeof window.history.state === 'object'
      ? window.history.state
      : {}

    // 回退完成后写入当前页面，清空原来可返回入驻页的前进记录
    window.history.pushState({...currentState}, document.title, window.location.href)
  })
}

export default router




// WEBPACK FOOTER //
// ./src/router/index.js